export const frontmatter = {
    "title": "Preguntas frecuentes",
    "description": "Respuestas a las preguntas más comunes sobre OnnIA.",
    "sidebar_label": "FAQs",
    "sidebar_group": "referencia",
    "sidebar_order": 2,
    "toc": false,
    "hide_title": true
}

export const toc = [
    {
        "depth": 2,
        "id": "empezar",
        "value": "Empezar"
    },
    {
        "depth": 2,
        "id": "canales",
        "value": "Canales"
    },
    {
        "depth": 2,
        "id": "agentes-e-inteligencia-artificial",
        "value": "Agentes e inteligencia artificial"
    },
    {
        "depth": 2,
        "id": "datos-y-seguridad",
        "value": "Datos y seguridad"
    }
]